__turbopack_context__.v({
  "attributesSkeleton": "styles-module__AiqFuq__attributesSkeleton",
  "modalContent": "styles-module__AiqFuq__modalContent",
  "productGrid": "styles-module__AiqFuq__productGrid",
  "scrollableItemRow": "styles-module__AiqFuq__scrollableItemRow",
  "seeMoreText": "styles-module__AiqFuq__seeMoreText",
});
